export default __webpack_public_path__ + "static/media/01_jelen_Pospisil-min.b1cc664b.jpg";